import React from 'react'
import './whatssap.css'

export default function Whatssap() {
  return (
    <div className="whatssap">
        <div className="content">
                <a href="https://wa.me/0716288654" target="_blank"><i className="fa-brands fa-whatsapp"></i></a>
        </div>
    </div>
  )
}
